const COMMON_PREFIX = "CART_FOOTER";

export const CART_FOOTER_TEST_IDS = {
    CHANGE_ADDRESS_BTN: `${COMMON_PREFIX}_CHANGE_ADDRESS`,
    SELECT_ADDRESS_BTN: `${COMMON_PREFIX}_SELECT_ADDRESS`,
    ADD_NEW_ADDRESS_BTN: `${COMMON_PREFIX}_ADD_NEW_ADDRESS`,
    ADDRESS_SELECTOR_ICON: `${COMMON_PREFIX}_ADDRESS_SELECTOR_ICON`,
    ADDRESS_SELECTOR_ANNOTATION: `${COMMON_PREFIX}_ADDRESS_SELECTOR_ANNOTATION`,
    ADD_ADDRESS_TO_PROCEED_BTN: `${COMMON_PREFIX}_ADD_ADDRESS_TO_PROCEED`,
    VIEW_DETAILED_BILL_BTN: `${COMMON_PREFIX}_VIEW_DETAILED_BILL`,
    BILL_TOTAL: `${COMMON_PREFIX}_BILL_TOTAL`,
    MAKE_PAYMENT: `${COMMON_PREFIX}_MAKE_PAYMENT`,
    LOGIN_TO_CONTINUE: `${COMMON_PREFIX}_LOGIN_TO_CONTINUE`,
    CART_FOOTER_ADDRESS_ANNOTATION: `${COMMON_PREFIX}_ADDRESS_ANNOTATION`,
    CART_FOOTER_ADDRESS_ICON: `${COMMON_PREFIX}_ADDRESS_ICON`,
    CART_FOOTER_ADDRESS_AREA: `${COMMON_PREFIX}_ADDRESS_AREA`,
    CART_FOOTER_ADDRESS_SLA: `${COMMON_PREFIX}_ADDRESS_SLA`,
};

export const SELECT_ADDRESS_TEST_IDS = {
    SELECT_ADDRESS_HEADER: "SELECT_ADDRESS_HEADER",
    SELECT_ADDRESS_LIST: "SELECT_ADDRESS_LIST",
    SELECT_ADDRESS_LIST_ADD_NEW_ADDRESS: "SELECT_ADDRESS_LIST_ADD_NEW_ADDRESS",
    SELECT_ADDRESS_LIST_ADDRESS: "SELECT_ADDRESS_LIST_ADDRESS",
    SELECT_ADDRESS_LIST_ADDRESS_ANNOTATION: "SELECT_ADDRESS_LIST_ADDRESS_ANNOTATION",
    SELECT_ADDRESS_LIST_ADDRESS_LOCATION: "SELECT_ADDRESS_LIST_ADDRESS_LOCATION",
    SELECT_ADDRESS_LIST_ADDRESS_SLA: "SELECT_ADDRESS_LIST_ADDRESS_SLA",
    SELECT_ADDRESS_LIST_ADDRESS_DISTANCE: "SELECT_ADDRESS_LIST_ADDRESS_DISTANCE",
    SELECT_ADDRESS_LIST_ADDRESS_ICON: "SELECT_ADDRESS_LIST_ADDRESS_ICON",
};
